import type { ResourceIDToResource } from "@/client/core/Core.api";
import type { LabsResourceID } from "@/client/core/platform-types/labs.api";
import {
    isLabsAudioResource,
    isLabsJsonResource,
    isLabsMidiResource,
} from "@/client/core/platform-types/labs.api";

export const filterAudioResources = (resources: Readonly<ResourceIDToResource>) => {
    return Array.from(resources.values()).filter(isLabsAudioResource);
};

export const filterAudioResource = (
    id: LabsResourceID,
    resources: Readonly<ResourceIDToResource>,
) => {
    const resource = resources.get(id.value);
    if (resource === undefined || !isLabsAudioResource(resource)) {
        return undefined;
    }
    return resource;
};

export const filterMidiResource = (
    id: LabsResourceID,
    resources: Readonly<ResourceIDToResource>,
) => {
    const resource = resources.get(id.value);
    if (resource === undefined || !isLabsMidiResource(resource)) {
        return undefined;
    }
    return resource;
};

export const filterJsonResource = (
    id: LabsResourceID,
    resources: Readonly<ResourceIDToResource>,
) => {
    const resource = resources.get(id.value);
    if (resource === undefined || !isLabsJsonResource(resource)) {
        return undefined;
    }
    return resource;
};
